import { render, staticRenderFns } from "./PaymentMethodConfirm.vue?vue&type=template&id=1c4f80f3"
import script from "./PaymentMethodConfirm.vue?vue&type=script&lang=js"
export * from "./PaymentMethodConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4f80f3')) {
      api.createRecord('1c4f80f3', component.options)
    } else {
      api.reload('1c4f80f3', component.options)
    }
    module.hot.accept("./PaymentMethodConfirm.vue?vue&type=template&id=1c4f80f3", function () {
      api.rerender('1c4f80f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaymentMethodConfirm.vue"
export default component.exports